/* eslint-disable */
import Vue from 'vue'
import axios from 'axios'
// import TWEEN from '@tweenjs/tween.js'

window.axios = axios
window.Vue = Vue
window.API_URL = 'https://dev.everphotoshoot.com/adminapi/'
// window.TWEEN = TWEEN

// FIREBASE SETUP
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
// import 'firebase/messaging'
import 'firebase/storage'

window.firebase = firebase
const FIREBASE_NAME = 'lbc-calendar'
const FIREBASE_API_KEY = 'AIzaSyAIv52UGDr9wkAbG4MoHf8cwj9-i2pWC38'

firebase.initializeApp({
  apiKey: FIREBASE_API_KEY,
  authDomain: FIREBASE_NAME + '.firebaseapp.com',
  databaseURL: 'https://' + FIREBASE_NAME + '.firebaseio.com',
  storageBucket: 'gs://lbc-calendar.appspot.com/',
})

// window.stripe = Stripe('pk_test_miffDht76xu1Ckw5AIw0CAJz')
// window.elements = stripe.elements()
// window.cardElement = elements.create('card')
